// src/components/navigation/AppStack.tsx
import React from "react";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import { AuthStackParamList } from "./navigationTypes";

import { DashboardScreen } from "../screens/dashboard/DashboardScreen";
import { SadhanaMenuScreen } from "../../components/screens/dashboard/SadhanaMenuScreen";
import { EditProfileScreen } from "../screens/profile/EditProfileScreen";

import { DandvatsScreen } from "../screens/Sadhana/dandvats/DandvatsScreen";
import { DandvatHistoryScreen } from "../screens/Sadhana/dandvats/DandvatHistoryScreen";
import { ManglaAartiScreen } from "../screens/Sadhana/ManglaAarti/ManglaAartiScreen";
import { ManglaAartiHistoryScreen } from "../screens/Sadhana/ManglaAarti/ManglaAartiHistoryScreen";
import { ReadingScreen } from "../screens/Sadhana/reading/ReadingScreen";
import { ReadingHistoryScreen } from "../screens/Sadhana/reading/ReadingHistoryScreen";
import { HearingScreen } from "../screens/Sadhana/hearing/HearingScreen";
import { HearingHistoryScreen } from "../screens/Sadhana/hearing/HearingHistoryScreen";
import { DeityWorshipScreen } from "../screens/Sadhana/DeityWorshipScreen/DeityWorshipScreen";
import { DeityWorshipHistoryScreen } from "../screens/Sadhana/DeityWorshipScreen/DeityWorshipHistoryScreen";
import { HealthMenuScreen } from "../screens/dashboard/HealthMenuScreen";
import { DietChartScreen } from "../screens/health/dietChart/DietChartScreen";
import { DietChartHistoryScreen } from "../screens/health/dietChart/DietChartHistoryScreen";
import { ExerciseScreen } from "../screens/health/Exercise/ExerciseScreen";
import { ExerciseHistoryScreen } from "../screens/health/Exercise/ExerciseHistoryScreen";
import { UpGradationScreen } from "../screens/Sadhana/upgradation/UpGradationScreen";
import { UpGradationHistoryScreen } from "../screens/Sadhana/upgradation/UpGradationHistoryScreen";
import { SringarScreen } from "../screens/Sadhana/sringar/SringarScreen";
import { SringarHistoryScreen } from "../screens/Sadhana/sringar/SringarHistoryScreen";
import { ChantingScreen } from "../screens/Sadhana/Chanting/ChantingScreen";
import { ChantingHistoryScreen } from "../screens/Sadhana/Chanting/ChantingHistoryScreen";
import { PranayamScreen } from "../screens/health/pranayam/PranayamScreen";
import { PranayamHistoryScreen } from "../screens/health/pranayam/PranayamHistoryScreen";
import SadhanaTrackerScreen from "../screens/dashboard/SadhanaTrackerScreen";
import { VersionDetailsScreen } from "../screens/version/VersionDetailsScreen";
import { AdminConsoleScreen } from "../screens/dashboard/AdminConsoleScreen";
import { OtherSevaScreen } from "../screens/Sadhana/OtherSevaScreen/OtherSevaScreen";
import { OtherSevaHistoryScreen } from "../screens/Sadhana/OtherSevaScreen/OtherSevaHistoryScreen";

const Stack = createNativeStackNavigator<AuthStackParamList>();
const Dummy = () => null;

export function AppStack() {
    return (
        <Stack.Navigator screenOptions={{ headerShown: false }}>
            {/* ✅ Logged-in Home */}
            <Stack.Screen name="Dashboard" component={DashboardScreen} />
            <Stack.Screen name="AdminConsole" component={AdminConsoleScreen} />
            <Stack.Screen name="SadhanaTracker" component={SadhanaTrackerScreen} />
            <Stack.Screen name="VersionDetails" component={VersionDetailsScreen} />

            {/* ✅ Dashboard tiles */}
            <Stack.Screen name="SadhanaMenu" component={SadhanaMenuScreen} />
            <Stack.Screen name="Health" component={HealthMenuScreen} />

            {/* ✅ Profile */}
            <Stack.Screen name="EditProfile" component={EditProfileScreen} />

            {/* ✅ Dandvats */}
            <Stack.Screen name="Dandvats" component={DandvatsScreen} />
            <Stack.Screen name="DandvatsHistory" component={DandvatHistoryScreen} />

            {/* ✅ ManglaAarti */}
            <Stack.Screen name="ManglaAarti" component={ManglaAartiScreen} />
            <Stack.Screen name="ManglaAartiHistory" component={ManglaAartiHistoryScreen} />

            {/* ✅ Reading */}
            <Stack.Screen name="ReadingScreen" component={ReadingScreen} />
            <Stack.Screen name="ReadingHistoryScreen" component={ReadingHistoryScreen} />

            {/* ✅ Hearing */}
            <Stack.Screen name="Hearing" component={HearingScreen} />
            <Stack.Screen name="HearingHistory" component={HearingHistoryScreen} />

            {/* ✅ DietyWorship */}
            <Stack.Screen name="DeityWorship" component={DeityWorshipScreen} />
            <Stack.Screen name="DeityWorshipHistory" component={DeityWorshipHistoryScreen} />

            {/* ✅ DietChart */}
            <Stack.Screen name="DietChart" component={DietChartScreen} />
            <Stack.Screen name="DietChartHistory" component={DietChartHistoryScreen} />

            {/* ✅ Exercise */}
            <Stack.Screen name="Exercise" component={ExerciseScreen} />
            <Stack.Screen name="ExerciseHistory" component={ExerciseHistoryScreen} />

            {/* ✅ UpGradation */}
            <Stack.Screen name="UpGradation" component={UpGradationScreen} />
            <Stack.Screen name="UpGradationHistory" component={UpGradationHistoryScreen} />

            {/* ✅ Sringar */}
            <Stack.Screen name="Sringar" component={SringarScreen} />
            <Stack.Screen name="SringarHistory" component={SringarHistoryScreen} />

            {/* ✅ Chanting */}
            <Stack.Screen name="Chanting" component={ChantingScreen} />
            <Stack.Screen name="ChantingHistory" component={ChantingHistoryScreen} />

            {/* ✅ Chanting */}
            <Stack.Screen name="Pranayam" component={PranayamScreen} />
            <Stack.Screen name="PranayamHistory" component={PranayamHistoryScreen} />

            <Stack.Screen name="PracticalSeva" component={Dummy} />
            <Stack.Screen name="SandhyaAarti" component={Dummy} />
            <Stack.Screen name="ScoreTracker" component={Dummy} />

             {/* ✅ other seva */}
            <Stack.Screen name="OtherSeva" component={OtherSevaScreen} />
            <Stack.Screen name="OtherSevaHistory" component={OtherSevaHistoryScreen} />
        </Stack.Navigator>
    );
}
